import configs from "config";
import { useAuth } from "hooks";
import useAccessKey from "hooks/useAccessKey";
import { IntercomProvider } from "react-use-intercom";
import { AppRouter } from "Router";

window.Buffer = window.Buffer || require("buffer").Buffer;
function App() {
  useAccessKey();
  useAuth();
  return (
    <IntercomProvider appId={configs.INTERCOM_TOKEN}>
      <AppRouter />
    </IntercomProvider>
  );
}

export default App;
